export default "__VITE_ASSET__DB3Ym7kk__"